<div class="m-textfield"
     :class="[{ 'm--is-disabled': isDisabled,
                'm--is-readonly': isReadonly,
                'm--is-waiting': isWaiting,
                'm--has-error': hasTextfieldError,
                'm--is-valid': isTextfieldValid,
                'm--has-label': hasLabel,
                'm--has-word-wrap': hasWordWrap,
                'm--has-validation-message': hasValidationMessage },
                'm--is-type-' + inputType ]"
     @click="onClick"
     :style="{ width: inputWidth, maxWidth: inputMaxWidth }">
    <m-input-style :disabled="isDisabled"
                   :waiting="isWaiting"
                   :error="hasTextfieldError"
                   :valid="isTextfieldValid"
                   :label="label"
                   :label-for="id"
                   :append="append"
                   :focus="isFocus"
                   :label-up="labelUp"
                   :empty="isEmpty"
                   :readonly="isReadonly"
                   :required-marker="requiredMarker"
                   :tag-style="tagStyle">
        <input v-if="!hasWordWrap"
               :id="id"
               class="m-textfield__input"
               v-model="model"
               :autocomplete="autocomplete"
               :disabled="isDisabled || isWaiting"
               :placeholder="placeholder"
               :readonly="isReadonly"
               :maxlength="maxLengthNumber"
               :type="inputType"
               @blur="onBlur"
               @change="onChange"
               @focus="onFocus"
               @keyup="onKeyup"
               @keydown="onKeydown"
               @paste="onPaste"
               ref="input" />
        <template v-if="!hasWordWrap"
                  slot="suffix">
            <transition name="m--is"
                        style="white-space: nowrap;">
                <m-icon-button v-if="passwordIcon && hasValue"
                               class="m-textfield__icon-password"
                               :aria-controls="id"
                               :title="passwordIconDescription"
                               :icon-name="passwordIconName"
                               @click="togglePasswordVisibility"
                               key="passwordIcon"
                               button-size="22px"></m-icon-button>
                <slot name="suffix"></slot>
            </transition>
        </template>
        <template slot="append">
            <slot name="append"></slot>
        </template>
        <textarea v-if="hasWordWrap"
                  :id="id"
                  class="m-textfield__input"
                  v-model="model"
                  :autocomplete="autocomplete"
                  :disabled="isDisabled || isWaiting"
                  :placeholder="placeholder"
                  :readonly="isReadonly"
                  :maxlength="maxLengthNumber"
                  @focus="onFocus"
                  @blur="onBlur"
                  @change="onChange"
                  @keypress.enter.prevent
                  @keyup="onKeyup"
                  @keydown="onKeydown"
                  @paste="onPaste"
                  v-m-textarea-auto-height
                  rows="1"
                  ref="input">
        </textarea>
    </m-input-style>
    <div class="m-textfield__validation">
        <m-validation-message class="m-textfield__validation__message"
                              :disabled="isDisabled"
                              :waiting="isWaiting"
                              :error="hasTextfieldError"
                              :error-message="errorMessage"
                              :valid="isTextfieldValid"
                              :valid-message="validMessage"
                              :helper-message="helperMessage"></m-validation-message>
        <m-character-count v-if="characterCount"
                           class="m-textfield__validation__character-count"
                           :value-length="valueLength"
                           :max-length="maxLength"
                           :threshold="characterCountThreshold"></m-character-count>
    </div>
</div>
